import { LuhnValidationError } from '../models/validation-errors.model';

/**
 * Validates a card number using Luhn algorithm with reason-specific error codes.
 * @param value - Card number string (spaces allowed)
 * @returns ValidationErrors with reason code or null if valid
 */
export function validateLuhn(value: string): LuhnValidationError | null {
  if (!value) return null;

  // Remove whitespace
  const cardNumber = value.replace(/\s/g, '');

  // Check for non-numeric characters
  if (!/^\d+$/.test(cardNumber)) {
    return { luhn: { reason: 'nonNumeric' } };
  }

  // Check length (most cards are 13-19 digits)
  if (cardNumber.length < 13 || cardNumber.length > 19) {
    return {
      luhn: {
        reason: 'length',
        min: 13,
        max: 19,
        actual: cardNumber.length,
      },
    };
  }

  // Luhn checksum algorithm
  const digits = cardNumber.split('').map(Number).reverse();
  let sum = 0;

  for (let i = 0; i < digits.length; i++) {
    let digit = digits[i];
    if (i % 2 === 1) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
  }

  if (sum % 10 !== 0) {
    return { luhn: { reason: 'checksum' } };
  }

  return null;
}
